import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DsProgressBarComponent } from "./ds-progress-bar.component";

@NgModule({
  declarations: [DsProgressBarComponent],
  imports: [CommonModule],
  exports: [DsProgressBarComponent],
})
export class DsProgressBarModule {}
